import { useState, useCallback, useRef, useEffect } from "react";
import LoaderTransparent from "../../components/ui/LoaderTransparent";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toast } from 'primereact/toast';
import { TabView, TabPanel } from 'primereact/tabview';
import { useNavigate } from "react-router-dom";
import Tabla from "./componentsUsuario/Tabla.js";
import { getUsuariosTabla } from "../../service/AffariService.js";


const Usuarios = () => {
    const [loading, setLoading] = useState(false);
    const [tabla, setTabla] = useState();
    const navigate = useNavigate();
    const toast = useRef(null);

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const data = await getUsuariosTabla({
            });
            setTabla(data?.usuarios || []);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);
    
        
    return (
        <div className="p-2">
            <Toast ref={toast} position="top-right" appendTo={document.body} baseZIndex={4000} />
            <div className="flex flex-column overflow-hidden" style={{ height: 'calc(100vh - 6rem)' }}>
                <Card className="bg-blue-50 border-bottom-1 border-blue-200 py-2 px-3 mb-2">
                    <h3 className="m-0 text-blue-700">Mantenedor de Usuarios</h3>
                </Card>
                <Card>
                    <div className="p-fluid flex-1 mt-2">
                        <div className="h-full flex flex-column" style={{ position: 'relative' }}>
                            {loading && <LoaderTransparent coverParent overlayTint="transparent" />}
                            <TabView className="h-full flex flex-column">
                                <TabPanel header="Activos" contentClassName="h-full flex flex-column">
                                    <div className="h-full flex flex-column p-2" style={{ position: 'relative' }}>
                                        <Tabla
                                            usuarios={Array.isArray(tabla) ? tabla.filter((u) => u.activo) : []}
                                            onRefresh={fetchData}
                                            setLoading={setLoading}
                                            toast={toast}
                                            fetchData={fetchData}
                                        />
                                    </div>
                                </TabPanel>
                                <TabPanel header="Inactivos" contentClassName="h-full flex flex-column">
                                    <div className="h-full flex flex-column p-2" style={{ position: 'relative' }}>
                                        <Tabla
                                            usuarios={Array.isArray(tabla) ? tabla.filter((u) => !u.activo) : []}
                                            onRefresh={fetchData}
                                            setLoading={setLoading}
                                            toast={toast}
                                            fetchData={fetchData}
                                        />
                                    </div>
                                </TabPanel>
                            </TabView>    
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default Usuarios;
